import { MODULE } from "./editor.actionTypes";

export const isFetchingTemplateStatus = (state) =>
  state.getIn([MODULE, "isFetchingTemplateStatus"]);

export const isSavingTemplateStatus = (state) => state.getIn([MODULE, "isSavingTemplateStatus"]);

export const getTemplate = (state) => state.getIn([MODULE, "template"]);
